var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "204px",
    height: "204px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 19.5,
    width: 16,
    height: 61,
    fill: "#1d3f72"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    repeatCount: "indefinite",
    dur: "1.0204081632653061s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "7.300000000000004;19.5;19.5",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.20408163265306123s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    repeatCount: "indefinite",
    dur: "1.0204081632653061s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "85.39999999999999;61;61",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.20408163265306123s"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 19.5,
    width: 16,
    height: 61,
    fill: "#5699d2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    repeatCount: "indefinite",
    dur: "1.0204081632653061s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "10.350000000000009;19.5;19.5",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.10204081632653061s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    repeatCount: "indefinite",
    dur: "1.0204081632653061s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "79.29999999999998;61;61",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.10204081632653061s"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 19.5,
    width: 16,
    height: 61,
    fill: "#d8ebf9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    repeatCount: "indefinite",
    dur: "1.0204081632653061s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "10.350000000000009;19.5;19.5",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    repeatCount: "indefinite",
    dur: "1.0204081632653061s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "79.29999999999998;61;61",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.b88b8f90d9d90c196f0d674e812108f6.svg";
export { ForwardRef as ReactComponent };